import { render } from "./OrganizationSettingsCategoryNav.vue?vue&type=template&id=21501c4a"
import script from "./OrganizationSettingsCategoryNav.vue?vue&type=script&lang=js"
export * from "./OrganizationSettingsCategoryNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__